import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import { generateUrls } from '@hooks/useBrand'
import useBrandGroup, { useBrandGroupForm } from '@hooks/useBrandGroup'

import { digObject, generateRedirectUrl } from '@domain-group/javascript-utils'

import EntityActivity from '@components/EntityActivity'
import LinkToEntityModule from '@components/LinkToEntityModule'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import PageLayout from '../../../../components/PageLayout'
import BrandGroupDetails from '../BrandGroupDetails'
import BrandGroupMembers from '../BrandGroupMembers'
import BrandGroupProviders from '../BrandGroupProviders'
import BrandGroupPublications from '../BrandGroupPublications'
import BrandGroupSettings from '../BrandGroupSettings'

const PageContent = (props: { brandGroupId: number}) => {
  const { brandGroupId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateBrandGroup,
    },
  } = pageContext

  const brandGroupPayload = useBrandGroup({ id: brandGroupId })
  const {
    brand,
    brandGroup,
    callbacks: {
      updateBrandGroup: updateFn,
    },
    loading,
    updating,
  } = brandGroupPayload

  // @ts-expect-error TS2345
  const brandGroupFormPayload = useBrandGroupForm(brandGroup, { validateOn: 'change' })
  const { entityState, saveEnabled } = brandGroupFormPayload

  const {
    title: brandTitle,
    business_name: brandBusinessName,
    logo: brandLogo,
  } = brand || {}

  const brandImageUrl = digObject(brandLogo || {}, 'small', '')
  const { editBrandUrl } = generateUrls(brand)

  const updateBrandGroupPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    // @ts-expect-error TS2339
    requestOptions: defaultRequestOptions.brandGroup,
    toastText: 'Brand Group Updated',
  }

  return (
    <PageLayout entityPayload={brandGroupPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <BrandGroupDetails brandGroupFormPayload={brandGroupFormPayload} />

            <BrandGroupProviders brandGroupId={brandGroupId} />

            <BrandGroupPublications brandGroupId={brandGroupId} />

            <BrandGroupMembers brandGroupId={brandGroupId} />

            <EntityActivity subjectId={brandGroupId} subjectType="BrandGroup" />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                marginLeft="auto"
                onClick={() => updateBrandGroup(updateBrandGroupPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          <LinkToEntityModule
            entityTitle={brandTitle || ''}
            goToHref={`${editBrandUrl}?redirect=${generateRedirectUrl()}`}
            imageUrl={brandImageUrl}
            loading={loading}
            moduleTitle="Brand"
            secondaryText={brandBusinessName}
          />
        </ScopedConditionalContent>

        <BrandGroupSettings
          brandGroupFormPayload={brandGroupFormPayload}
          brandGroupPayload={brandGroupPayload}
        />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
